import Lifecycle from "./Lifecycle";
export default function Offboarding() {
  return <Lifecycle initialTab="offboarding" />;
}
